var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "供应商名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.supplierName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "supplierName", $$v)
                                },
                                expression: "listPram.supplierName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "归属公司" } }, [
                        _c(
                          "div",
                          { staticClass: "selWidth " },
                          [
                            _c("SelectCompay", {
                              on: { selectCompany: _vm.selectCompany },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "合作状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择合作状态",
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.cooperationStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listPram,
                                    "cooperationStatus",
                                    $$v
                                  )
                                },
                                expression: "listPram.cooperationStatus",
                              },
                            },
                            _vm._l(_vm.typeOpetion, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销方式" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择核销方式",
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.writeOffType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "writeOffType", $$v)
                                },
                                expression: "listPram.writeOffType",
                              },
                            },
                            _vm._l(_vm.verificationOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "维护人" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择维护人",
                                filterable: "",
                                "filter-method": _vm.handleUserSearch,
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.maintainerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "maintainerId", $$v)
                                },
                                expression: "listPram.maintainerId",
                              },
                            },
                            _vm._l(_vm.userOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    "" +
                                    item.realName +
                                    (item.flag == 1 ? "（当前登陆人）" : ""),
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "归属小程序" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择归属小程序",
                              },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.customerId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "customerId", $$v)
                                },
                                expression: "listPram.customerId",
                              },
                            },
                            _vm._l(_vm.miniProgramOptions, function (opt) {
                              return _c("el-option", {
                                key: opt.id,
                                attrs: { label: opt.name, value: opt.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.miniProgramCustomer
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "运营平台" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handerSearch },
                                  model: {
                                    value: _vm.listPram.platformId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "platformId", $$v)
                                    },
                                    expression: "listPram.platformId",
                                  },
                                },
                                _vm._l(
                                  _vm.operationPlatform,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.appName,
                                        value: item.customerId,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否配置有效活动" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.hasActiveActivity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listPram,
                                    "hasActiveActivity",
                                    $$v
                                  )
                                },
                                expression: "listPram.hasActiveActivity",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "否", value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["admin:supplier:physical:save"],
                      expression: "['admin:supplier:physical:save']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerOpenEdit(0)
                    },
                  },
                },
                [_vm._v("新增供应商")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "id", "min-width": "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "LOGO", "min-width": "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.logo
                          ? _c("el-image", {
                              staticStyle: {
                                width: "40px",
                                height: "40px",
                                cursor: "pointer",
                              },
                              attrs: {
                                src: scope.row.logo,
                                "preview-src-list": [scope.row.logo],
                                "append-to-body": true,
                                fit: "cover",
                                "preview-teleported": "",
                              },
                            })
                          : _c("span", { staticClass: "text-placeholder" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "discountRate",
                  label: "折扣率",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.discountRate !== undefined &&
                        scope.row.discountRate !== null
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.discountRate) +
                                  "% "
                              ),
                              scope.row.discountRate
                                ? _c("span", [
                                    _vm._v(
                                      " (" +
                                        _vm._s(
                                          (scope.row.discountRate / 10)
                                            .toString()
                                            .replace(/\.0$/, "")
                                        ) +
                                        "折)"
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "归属公司",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cooperationStatus",
                  label: "合作状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            _vm.transformState(
                              _vm.typeOpetion,
                              scope.row.cooperationStatus,
                              "value"
                            )
                          )
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ticketType",
                  label: "票务类型",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("span", {}, [
                        _vm._v(
                          _vm._s(
                            _vm.transformState(
                              _vm.cardOpetion,
                              scope.row.ticketType
                            )
                          )
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "归属小程序", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.miniProgramList &&
                        scope.row.miniProgramList.length
                          ? [
                              _c(
                                "span",
                                {
                                  staticClass: "mini-program-names",
                                  attrs: {
                                    title: scope.row.miniProgramList
                                      .map(function (i) {
                                        return (
                                          i.customerName ||
                                          "客户" + i.customerId
                                        )
                                      })
                                      .join("、"),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        scope.row.miniProgramList
                                          .map(function (i) {
                                            return (
                                              i.customerName ||
                                              "客户" + i.customerId
                                            )
                                          })
                                          .join("、")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          : _c("span", { staticClass: "text-placeholder" }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "account", label: "商户号", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "amount", label: "余额" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "freezeAmount", label: "冻结金额" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "maintainerName",
                  label: "维护人",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "writeOffType",
                  label: "核销方式",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.writeOffType === 1
                          ? _c("span", [_vm._v("小程序")])
                          : scope.row.writeOffType === 2
                          ? _c("span", [_vm._v("扫码枪")])
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "是否配置有效活动", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.hasActiveActivity
                                ? "success"
                                : "info",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.hasActiveActivity ? "是" : "否"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "weChatGroupName",
                  label: "微信群名称",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "接口参数", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.writeOffType !== 2
                          ? _c("span", [_vm._v("-")])
                          : _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleWriteOffAction(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n          接口参数\n          ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "200",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:supplier:entity:update"],
                                expression: "['admin:supplier:entity:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerOpenEdit(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:instant:discount:list"],
                                expression: "['admin:instant:discount:list']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleGoMarketing(scope.row)
                              },
                            },
                          },
                          [_vm._v("营销配置")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:supplier:entity:delete"],
                                expression: "['admin:supplier:entity:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.editDialogConfig.visible,
            title:
              _vm.editDialogConfig.isEdit == 0 ? "添加供应商" : "编辑供应商",
            top: "1vh",
            width: "1200px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _vm.editDialogConfig.visible
            ? _c("edit", {
                attrs: {
                  supplierType: 4,
                  showWriteOffType: true,
                  editId: _vm.editDialogConfig.editId,
                },
                on: {
                  closeEdit: function ($event) {
                    _vm.editDialogConfig.visible = false
                  },
                  hideDialog: _vm.handlerHideDialog,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.settingDialogConfig.visible,
            title: "开发配置",
            top: "1vh",
            width: "1200px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.settingDialogConfig, "visible", $event)
            },
          },
        },
        [
          _vm.settingDialogConfig.visible
            ? _c("SettingEdit", {
                attrs: { editId: _vm.settingDialogConfig.editId },
                on: {
                  closeEdit: function ($event) {
                    _vm.settingDialogConfig.visible = false
                  },
                  hideDialog: _vm.handlerHideDialog,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("SettingProduct", { ref: "SettingProductRef" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.interfaceDialogConfig.visible,
            title: "接口参数",
            width: "500px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.interfaceDialogConfig, "visible", $event)
            },
          },
        },
        [
          _c("div", { staticClass: "interface-params" }, [
            _c("div", { staticClass: "param-item" }, [
              _c("label", [_vm._v("App ID：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.interfaceDialogConfig.appId))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "param-item" }, [
              _c("label", [_vm._v("Private Key：")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.interfaceDialogConfig.privateKey)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.interfaceDialogConfig.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }